// Updated authService.js with correct endpoints and better debugging
import apiClient, { withAuth } from './api';

export const authService = {
  verify: (token) => {
    return apiClient.get('/api/auth/verify/', withAuth(token));
  },
  
  validateToken: (token) => {
    return apiClient.get('/api/auth/validate', withAuth(token));
  },
  
  resendVerification: (data, token) => {
    return apiClient.post('/api/auth/resend-verification', data, withAuth(token));
  },
  
  getUserInfo: (token) => {
    return apiClient.get('/api/user-info/', withAuth(token));
  },
  
  updateUserEmail: (data, token) => {
    console.log('Updating user email with:', data);
    return apiClient.post('/api/user/update-email/', data, withAuth(token));
  },
  
  updatePassword: (data, token) => {
    return apiClient.post('/api/auth/update-password/', data, withAuth(token));
  },

  getUserProfile: (token) => {
    console.log('Getting user profile...');
    // Add cache-busting timestamp to prevent browser caching
    const timestamp = new Date().getTime();
    
    return apiClient.get(`/api/get-user-profile/?t=${timestamp}`, withAuth(token))
      .then(response => {
        console.log('User profile retrieved successfully');
        // Log the actual data being returned
        if (response.data && response.data.data) {
          console.log('Profile data received:', {
            first_name: response.data.data.first_name,
            last_name: response.data.data.last_name,
            email: response.data.data.email
          });
        }
        return response;
      })
      .catch(error => {
        console.error('Error getting user profile:', error);
        throw error;
      });
  },

  updateUserProfile: (data, token) => {
    console.log('Updating user profile with data:', data);
    
    // Ensure that field names match the backend expectations
    const formattedData = { ...data };
    
    // Field name translation to ensure backend compatibility
    const fieldMappings = {
      'firstName': 'first_name',
      'lastName': 'last_name',
      'address1': 'address_line_1',
      'address2': 'address_line_2',
      'zip': 'zip_code',
      'phone': 'phone_number'
    };
    
    // Convert any camelCase field names to snake_case
    Object.keys(fieldMappings).forEach(frontendField => {
      if (frontendField in formattedData) {
        const backendField = fieldMappings[frontendField];
        formattedData[backendField] = formattedData[frontendField];
        delete formattedData[frontendField];
      }
    });
    
    console.log('Formatted data for backend:', formattedData);
    
    return apiClient.put('/api/update-user-profile/', formattedData, withAuth(token))
      .then(response => {
        console.log('User profile updated successfully:', response.data);
        return response;
      })
      .catch(error => {
        console.error('Error updating user profile:', error);
        console.error('Error details:', error.response?.data);
        throw error;
      });
  },
  
  public: () => {
    return apiClient.get('/api/public/');
  }
};

export default authService;